import React from 'react'

import { useSelector } from 'react-redux'

import { forDesktop } from 'decorators/device'
import { metaBreadcrumbsSelector } from 'redux/modules/meta'
import Breadcrumbs from 'UI/Breadcrumbs'

const BreadcrumbsContainer = props => {
  const items = useSelector(({ meta }) => metaBreadcrumbsSelector(meta))

  return <Breadcrumbs {...props}
    items={items} />
}

export default forDesktop(BreadcrumbsContainer)
